/**
 * TanStack Query hooks for `api-key-generation-permission-per-role`.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	list,
	upsert,
	apiKeyGenerationPermissionPerRoleQueryKeys,
	type ListRolePermissionsResponse,
	type UpsertRolePermissionBody,
	type UpsertRolePermissionResponse,
} from "./api";

export function useRolePermissionsList(): UseQueryResult<ListRolePermissionsResponse, Error> {
	return useQuery({
		queryKey: apiKeyGenerationPermissionPerRoleQueryKeys.list(),
		queryFn: list,
	});
}

export function useRolePermissionUpsert(): UseMutationResult<
	UpsertRolePermissionResponse,
	Error,
	UpsertRolePermissionBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: upsert,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: apiKeyGenerationPermissionPerRoleQueryKeys.all });
		},
	});
}
